// extracted by mini-css-extract-plugin
export var wrapper = "styledTextBox-module--wrapper--KUO1j";
export var wrapperLineBottom = "styledTextBox-module--wrapper-line-bottom--e+UXw";
export var wrapperLineTop = "styledTextBox-module--wrapper-line-top--HklmS";